"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_tracking_1 = require("react-tracking");
var I18n = require("i18n-js");
var elog = require("../../elog");
var bind_1 = require("../../bind");
var tracker_1 = require("../../tracker");
var marketing_callout_card_1 = require("./marketing_callout_card");
var overflowing_row_1 = require("../../components/overflowing_row");
var tiles_1 = require("../../components/tiles");
var sanitized_render_1 = require("../../components/sanitized_render");
var core_link_1 = require("../../components/core_link");
var url_helpers_1 = require("../../url_helpers");
var SIDEBAR_SECTION = 'sidebar';
var COMPONENT_NAME = 'MarketingCallout';
var MarketingCallout = /** @class */ (function (_super) {
    tslib_1.__extends(MarketingCallout, _super);
    function MarketingCallout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketingCallout.prototype.shouldBeTwoWide = function () {
        return this.props.tileSize === 'twoWide';
    };
    // includes default behavior (for legacy support)
    MarketingCallout.prototype.shouldBeThreeWide = function () {
        return (!this.props.tileSize ||
            this.props.tileSize === 'threeWide');
    };
    MarketingCallout.prototype.shouldBeSquare = function () {
        return this.props.tileSize === 'squareImages';
    };
    MarketingCallout.prototype.shouldGrow = function () {
        if (this.shouldBeSquare())
            return;
        return (this.shouldBeThreeWide() ||
            this.shouldBeTwoWide() ||
            (this.getLength() === 1));
    };
    // this allows content managers to be able to count on large tiles in this context
    // to be a multiple of 4 (default large tile behavior can result in 5-wide grids)
    MarketingCallout.prototype.shouldBeFourWideMax = function () {
        if (!this.props.displayAsGrid)
            return false;
        return this.shouldBeLargeTiles();
    };
    MarketingCallout.prototype.shouldBeLargeTiles = function () {
        return this.props.tileSize === 'largeTiles';
    };
    // we can't center flex items that are expected to overflow
    // and anything singleRow could potentially overflow
    MarketingCallout.prototype.shouldCenter = function () {
        if (!this.props.displayAsGrid)
            return;
        return this.shouldBeThreeWide() || this.shouldBeSquare();
    };
    MarketingCallout.prototype.shouldRenderForSidebar = function () {
        return this.props.layoutSection === SIDEBAR_SECTION;
    };
    MarketingCallout.prototype.getLength = function () {
        if (!this.props.callouts)
            return 0;
        return this.props.callouts.length;
    };
    MarketingCallout.prototype.renderCallout = function (calloutData) {
        return (React.createElement(marketing_callout_card_1.default, { key: calloutData.title, channel: calloutData.channel, imageURL: url_helpers_1.imageUploadURL(calloutData.image), pageType: calloutData.pageType, subtitle: calloutData.subtitleHtml || calloutData.subtitle, targetHref: calloutData.targetHref, title: calloutData.titleHtml || calloutData.title, wideCard: this.shouldBeTwoWide() && !this.shouldRenderForSidebar(), squareImage: this.shouldBeSquare() }));
    };
    MarketingCallout.prototype.renderCallouts = function () {
        return this.props.callouts.map(this.renderCallout);
    };
    MarketingCallout.prototype.renderForSidebar = function () {
        return (React.createElement("div", { className: "marketing-callout-sidebar-container" }, this.renderCallouts()));
    };
    MarketingCallout.prototype.renderAction = function () {
        if (!this.props.ctaTargetHref) {
            return;
        }
        return (React.createElement(core_link_1.default, { className: this.props.displayAsGrid && 'button button--orange', to: this.props.ctaTargetHref, interactionType: tracker_1.CTA }, this.props.ctaText
            ? this.props.ctaText
            : I18n.t('cms.marketingCallout.seeMore')));
    };
    MarketingCallout.prototype.renderTitle = function () {
        return (React.createElement(sanitized_render_1.default, { html: this.props.titleHtml || this.props.title }));
    };
    MarketingCallout.prototype.render = function () {
        try {
            if (this.shouldRenderForSidebar()) {
                return this.renderForSidebar();
            }
            return (React.createElement(overflowing_row_1.default, { title: this.renderTitle(), titleHtml: this.props.titleHtml, subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, action: this.renderAction(), appendAction: this.props.displayAsGrid, id: this.props.jumplinkSlug },
                React.createElement(tiles_1.default, { grow: this.shouldGrow(), twoWide: this.shouldBeTwoWide(), threeWide: this.shouldBeThreeWide() || this.shouldBeSquare(), largeTiles: this.shouldBeLargeTiles(), fourWideMax: this.shouldBeFourWideMax(), singleRow: !this.props.displayAsGrid, expectedCount: this.getLength(), placeholder: React.createElement(marketing_callout_card_1.default, null), centered: this.shouldCenter() }, this.renderCallouts())));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    // needed to prevent gql load order error
    MarketingCallout.defaultProps = {
        callouts: [],
    };
    tslib_1.__decorate([
        bind_1.default
    ], MarketingCallout.prototype, "renderCallout", null);
    MarketingCallout = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.MARKETING_TYPE,
                eventType: tracker_1.VIEW,
                context: {
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                },
            };
        }, { dispatchOnMount: true })
    ], MarketingCallout);
    return MarketingCallout;
}(React.Component));
exports.default = MarketingCallout;
//# sourceMappingURL=marketing_callout.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/marketing_callout.js
// module id = WSpk
// module chunks = 0 2 6 20